import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserProject = ({ project }) => {
  const navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [projectComments, setProjectComments] = useState([]);
  const [commentCount, setCommentCount] = useState(0);
  const [showComments, setShowComments] = useState(false);
  useEffect(() => {
    api
      .get(`/projects/comments/${project?._id}`)
      .then((res) => {
        console.log("project comments", res.data);
        if (res.data.length > 0) {
          setProjectComments(res.data);
          setCommentCount(res.data.length);
        }
      })
      .catch((err) => console.log);
  }, []);
  const deleteProject = (id) => {
    api
      .delete(`/projects/${id}`)
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };
  return (
    // <div className="row border-bottom border-dark pb-3">
    //   <div className="col-lg-6 col-md-6 col-12">
    //     <h5 className="title">
    //       <strong>{project?.title}</strong>
    //     </h5>
    //   </div>
    //   <div className="col-lg-6 col-md-6 col-12">
    //     <p>
    //       Posted:{" "}
    //       <strong className="date">
    //         {new Date(project?.createdAt).toDateString()}
    //       </strong>
    //     </p>
    //   </div>
    //   <div className="price">
    //     <p>
    //       <strong>Price: </strong>
    //       {project?.price} PKR
    //     </p>
    //   </div>
    //   <div className="deadline">
    //     <p>
    //       <strong>Deadline: </strong> {project?.deadline}
    //     </p>
    //   </div>
    //   <div className="type">
    //     <p>
    //       <strong>Project type : </strong> {project?.projectType}
    //     </p>
    //   </div>
    //   <div className="type">
    //     <p>
    //       <strong>Technology/Stack used : </strong> {project?.tech_used}
    //     </p>
    //   </div>
    //   <div className="desc">
    //     {project?.description ? (
    //       <p>{project?.description}</p>
    //     ) : (
    //       <p>no description</p>
    //     )}
    //   </div>

    //   {project?.projectImage && (
    //     <div style={{ marginBottom: "3vh" }}>
    //       <img
    //         src={project?.projectImage}
    //         style={{
    //           maxWidth: "20vw",
    //           height: "auto",
    //           width: "auto",
    //           maxHeight: "30vh",
    //         }}
    //       />
    //     </div>
    //   )}
    //   <div className="tags">
    //     {project?.tags.map((t) => (
    //       <span className="tag-span">{t}</span>
    //     ))}
    //   </div>
    //   <div className="col-lg-6 col-12 row mt-4">
    //     <h6 className="mb-1 mt-3"> Comments ({commentCount}) </h6>
    //     <span
    //       className="underline inline mb-3 pointer"
    //       onClick={() => setShowComments(!showComments)}
    //     >
    //       {" "}
    //       {!showComments ? "show" : "hide"}
    //     </span>

    //     {showComments && (
    //       <>
    //         {projectComments.length > 0 ? (
    //           projectComments.map((comment) => (
    //             <div className="show-comments mt-0 mb-0">
    //               <p>
    //                 <strong>{comment?.user.name}</strong>
    //               </p>
    //               <p>{comment?.comment}</p>
    //               <br />
    //             </div>
    //           ))
    //         ) : (
    //           <p>no comments</p>
    //         )}
    //       </>
    //     )}
    //   </div>
    //   <div className=" row  mt-3 mb-3 flex-box justify-left">
    //     <Link to={`/edit-project/${project?._id}`} className="btn   mr-6 btn">
    //       Edit Project
    //     </Link>
    //   </div>
    //   <button
    //     className="delete__scholarship__btn"
    //     onClick={(e) => deleteProject(project?._id)}
    //   >
    //     Delete Project
    //   </button>
    // </div>
    <Card sx={{ width: "100%", marginBottom: "20px" }}>
      <CardHeader
        avatar={
          <Stack direction="column">
            {currentUser?.profile ? (
              <Avatar
                src={currentUser?.profile}
                alt={currentUser?.name?.at(0)?.toUpperCase()}
              />
            ) : (
              <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                {currentUser?.name?.at(0)?.toUpperCase()}
              </Avatar>
            )}
          </Stack>
        }
        // action={
        //   <IconButton aria-label="settings">
        //     <MoreVertIcon />
        //   </IconButton>
        // }
        title={currentUser?.name?.toUpperCase()}
        subheader={new Date(project?.createdAt).toDateString()}
      />
      {/* {hostel?.hostelImage && (
      <CardMedia
        component="img"
        height="50"
        width="50"
        image={hostel?.hostelImage}
        alt="Paella dish"
      />
    )} */}

      <CardContent>
        <Typography
          sx={{
            fontSize: "1.5rem",
            marginBottom: "10px",
            fontWeight: "500",
            textTransform: "capitalize",
          }}
          color="fontPrimaryColor.main"
          className="question__title"
          // onClick={() => navigate(`/answers/${question._id}`)}
        >
          {project?.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {project?.description}
        </Typography>
        {project?.projectImage && (
          <img
            style={{
              margin: "20px 0",
              marginLeft: "50%",
              transform: "translateX(-50%)",
            }}
            height="auto"
            width="60%"
            src={project?.projectImage}
            alt="Paella dish"
          />
        )}
        <Box className="language mt-4 bg-white">
          <Box className="tags bg-white">
            {project?.tags?.map((t) => (
              <Typography className="tag-span">{t}</Typography>
            ))}
          </Box>
        </Box>
        {/* <Box className="mt-5">
        <Typography sx={{ fontSize: "1.2rem", fontWeight: "500" }}>
          Answers
        </Typography>
        <Box className="answer__container">
          {answers.length > 0 &&
            answers.map((ans) => (
              // <Box className="ans">
              //   <h1>{ans.user.name}</h1>
              //   <p>{ans.answer}</p>
              // </Box>
              <Answer ans={ans} />
            ))}
        </Box>
     
      </Box> */}
        <Box className="country mt-4 mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Price
          </Typography>
          <Typography variant="body2">{project?.price} PKR</Typography>
        </Box>
        <Box className="duration mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Deadline
          </Typography>
          <Typography>{project?.deadline} </Typography>
        </Box>
        <Box className="duration mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Project Type
          </Typography>
          <Typography>{project?.projectType} </Typography>
        </Box>
        <Box className="amount mb-4 mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Technology used
          </Typography>
          <Typography>
            {project?.tech_used ? project?.tech_used : "null"}
          </Typography>
        </Box>

        {/* <Box className="desc">
        <p>{hostel?.description ? hostel?.description : "no description"}</p>
      </Box> */}
        {/************= */}
        <div className="col-lg-6 col-12 row mt-4">
          <h6 className="mb-1 mt-3"> Comments ({commentCount}) </h6>
          <span
            className="underline inline mb-3 pointer"
            onClick={() => setShowComments(!showComments)}
          >
            {" "}
            {!showComments ? "show" : "hide"}
          </span>

          {showComments && (
            <>
              {projectComments.length > 0 ? (
                projectComments.map((comment) => (
                  <div className="show-comments mt-0 mb-0">
                    <p>
                      <strong>{comment?.user.name}</strong>
                    </p>
                    <p>{comment?.comment}</p>
                    <br />
                  </div>
                ))
              ) : (
                <p>no comments</p>
              )}
            </>
          )}
        </div>
      </CardContent>
      <CardActions>
        <div className="  mt-3 mb-3 flex-box justify-left ml-auto">
          <button
            onClick={() => navigate(`/edit-project/${project?._id}`)}
            className="asc__submit__form__button mr-2"
          >
            Edit Project
          </button>
        </div>
        <button
          className=" asc__submit__form__button mr-2"
          onClick={() => deleteProject(project?._id)}
        >
          Delete Project
        </button>
      </CardActions>
    </Card>
  );
};

export default UserProject;
